import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const buyers = [{
  name: 'Marcelo',
  location: 'Buenos Aires'
}, {
  name: 'Jorge',
  location: 'Rosario'
}, {
  name: 'Sofía',
  location: 'Córdoba'
}, {
  name: 'Valeria',
  location: 'Santa Fe'
}, {
  name: 'Carolina',
  location: 'Entre Ríos'
}];
export function SocialProofToast() {
  const [currentBuyer, setCurrentBuyer] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay before showing first toast
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  useEffect(() => {
    if (!isVisible) {
      // When hidden, wait random time (10-20s) before showing next
      const nextTimeout = setTimeout(() => {
        setCurrentBuyer(prev => (prev + 1) % buyers.length);
        setIsVisible(true);
      }, Math.random() * 10000 + 10000);
      return () => clearTimeout(nextTimeout);
    } else {
      // When visible, hide after 5s
      const hideTimeout = setTimeout(() => {
        setIsVisible(false);
      }, 5000);
      return () => clearTimeout(hideTimeout);
    }
  }, [isVisible]);
  return <AnimatePresence data-id="element-232">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 bg-white shadow-warm-lg rounded-xl p-4 border border-wood-light/20 flex items-center gap-4 max-w-sm" data-id="element-233">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-234">
            <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-235" />
          </div>
          <div data-id="element-236">
            <p className="text-sm text-charcoal font-medium" data-id="element-237">
              <span className="font-bold" data-id="element-238">{buyers[currentBuyer].name}</span> de{' '}
              {buyers[currentBuyer].location}
            </p>
            <p className="text-xs text-charcoal/60 mt-0.5" data-id="element-239">
              Acaba de comprar el Super Combo
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}